import StandardizeTable from './model';
import RequestTable from './with-request';
import './style/index';
var RefStandardizeTable = StandardizeTable;
RefStandardizeTable.RequestTable = RequestTable;
export default RefStandardizeTable;